import { Box, Flex, Text, Skeleton } from '@chakra-ui/react';
import React from 'react';
import EpcIcon from '../../icons/EpcIcon/EpcIcon';
import { makeMed2 } from '../../../styles/textStyles';
import { useTokens } from '../../../context/TokenProvider';
const EpcIndicator = ({ color, textColor, value, isLoading, ...rest }) => {
    const tokens = useTokens();
    return (React.createElement(Flex, { position: "absolute", color: "white", align: "center", justify: "center", "data-testid": "epc_indicator", ...rest },
        React.createElement(Skeleton, { isLoaded: !isLoading, borderRadius: "md" },
            React.createElement(Box, { position: "relative", display: "inline-block" },
                React.createElement(EpcIcon, { "data-testid": "epc_indicator__epc_icon", boxSize: "28px", color: color }),
                React.createElement(Text, { sx: makeMed2(tokens, { color: textColor }), position: "absolute", top: "50%", left: "60%", transform: "translate(-50%, -50%)", "data-testid": "epc_indicator__value" }, value)))));
};
export default EpcIndicator;
